import React from 'react'
import CertificateManagement from '../../pages-partial/CertificateManagement'

const CertificateGenerator = () => {
  return (
    <div><CertificateManagement /></div>
  )
}

export default CertificateGenerator;